import type { ReactNode } from 'react';
import styles from './ReviewCount.module.scss';
import FontAwesomeIcon, {
  regularComment
} from 'common/components/FontAwesomeIcon';

type Props = {
  reviewCount: number;
};

export function ReviewCount({ reviewCount }: Props): ReactNode {
  return (
    reviewCount > 0 && (
      <span className={styles.reviewCount}>
        <FontAwesomeIcon className={styles.icon} icon={regularComment} />
        {reviewCount}
      </span>
    )
  );
}
